const nf = new Intl.NumberFormat('th-TH')

export function money(n: number): string {
  const sign = n < 0 ? '−' : ''
  return `${sign}฿${nf.format(Math.abs(Math.round(n)))}`
}

export function signed(n: number): string {
  if (n === 0) return '฿0'
  return `${n > 0 ? '+' : '−'}฿${nf.format(Math.abs(Math.round(n)))}`
}

/** ย่อสำหรับพื้นที่แคบบนกระดาน: 60K / 2.4M */
export function short(n: number): string {
  const a = Math.abs(n)
  if (a >= 1_000_000) return `฿${(n / 1_000_000).toFixed(a >= 10_000_000 ? 0 : 1).replace(/\.0$/, '')}M`
  if (a >= 1_000) return `฿${Math.round(n / 1_000)}K`
  return `฿${n}`
}

export function pct(n: number): string {
  return `${(n * 100).toFixed(1)}%`
}

/** ตำแหน่งของช่องบนกริด 11x11 (แถว/คอลัมน์เริ่มที่ 1) */
export function tileGrid(i: number): { row: number; col: number; side: 'bottom' | 'left' | 'top' | 'right' } {
  if (i <= 10) return { row: 11, col: 11 - i, side: 'bottom' }
  if (i <= 20) return { row: 11 - (i - 10), col: 1, side: 'left' }
  if (i <= 30) return { row: 1, col: i - 20 + 1, side: 'top' }
  return { row: i - 30 + 1, col: 11, side: 'right' }
}

/** พิกัดกลางช่องเป็น % ของกระดาน — ใช้วางหมากผู้เล่น */
export function tileCenter(i: number): { left: number; top: number } {
  const { row, col } = tileGrid(i)
  const cell = 100 / 11
  return { left: (col - 0.5) * cell, top: (row - 0.5) * cell }
}
